import React from 'react'
import '../App.scss';
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import {connect} from 'react-redux'
import {appLoad} from  './../Store/Actions/AppLoadAction'
import Cookies from "js-cookie";
import Axios from "../Plugins/Axios";

class Progress extends React.Component{
    constructor() {
        super()
        this.state={
            text:null,
            token:null,
            loaderPercentage:1,
            success:false,
            interval:null,
            isPending: false,
            fetchedData:null,
        }
    }
    progressInterval=() =>{
        const interval =  setInterval(this.progress, 100);
        this.setState({
            interval:interval
        });
    }
    progress=async ()=>{
        this.setState((state) => ({
        loaderPercentage: state.loaderPercentage +1
        }));
        if (this.state.loaderPercentage===50){
            clearInterval(this.state.interval)
            await this.fetchData()
            // return
            if (this.state.success)
                this.progressInterval()
        }
        if (this.state.loaderPercentage===100){
            this.props.appLoad(this.state.token)
            clearInterval(this.state.interval)
            this.props.result({success: true,token:this.state.token})
        }
    }
    fetchData= async()=>{
         await axios.get(`users/new`)
             .then(res => {
                 const {token,data}=res.data
                 const Ax=new Axios()
                 Ax.setAuth(token)
                 // axios.defaults.headers.common['Authorization']=`Bearer ${token}`
                 // Cookies.set('token', token, { expires: 1})

                 this.setState({
                     text:data.texts.intro,
                     success:true,
                     token:token,
                 })
             }).catch(error=>{
                 this.props.result({success: false})
             }
     )
    }
    componentDidMount() {
        this.progressInterval()
    }
    render() {
        return (
            <div className="progress">
                <p style={{
                    textAlign:'center',
                    color:'white',
                    fontWeight:'bold',
                    height:'60px',
                    fontSize:'24px'
                }}>
                    {this.state.text}
                </p>
                <p>{this.state.loaderPercentage}%</p>
                <div className="progressbar">
                  <span style={{width:`${this.state.loaderPercentage}%`}}>
                  </span>
                </div>
            </div>
        )
    }
}
const mapStateToProps=state=>({
    AppLoad:state.AppLoad.appLoaded
})
export default connect(mapStateToProps,{appLoad})(Progress)